import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { OpportunityModel } from '@app/src/views/StepOne/form/models/opportunity';

export const opportunityService = {
  async get(operationId: number): Promise<OpportunityModel[]> {
    try {
      const { data } = await axiosAjax.get(
        process.env.API_OPPORTUNITY
          .replace(':operationId', '' + operationId)
      );
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
